export * from '@wix/ricos-common';
export { default as WixRicosEditor } from './WixRicosEditor';
//# sourceMappingURL=index.js.map